export const en = {
    request_approved: 'Request approved',
    request_not_approved: 'Request not approved',
};
